import React, { useState } from 'react';
import { InputBar, InputBar_Input } from 'emerald-ui';
import { SearchBar_Icon } from './SearchBar.style';

/**
 * @typedef SearchBarProps
 * @property {function} searchCallback The function to be called for looking up tracking information.
 */

/** @type {React.FC<SearchBarProps & React.HTMLAttributes<HTMLDivElement>>} */
export const SearchBar = ({
    searchCallback,
    ...otherProps
}) => {
    const [value, setValue] = useState('');

    /** @param {React.ChangeEvent<HTMLInputElement>} e */
    const handleChange = (e) => {
        setValue(e.target.value.replace(/[^a-zA-Z0-9]/gi, ''));
    };

    /** @param {React.KeyboardEvent<HTMLInputElement>} e */
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            searchCallback(value);
        }
    };

    return (
        <InputBar
            {...otherProps}
        >
            <InputBar_Input
                id='tracking-search'
                inputProps={{
                    'aria-label': 'Enter tracking number'
                }}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder='Enter tracking number'
                value={value}
            />
            <SearchBar_Icon />
        </InputBar>
    );
};
